import api from './api';

const patientService = {
  // Get all patients with optional filters
  getAllPatients: async (params = {}) => {
    const response = await api.get('/patients', { params });
    return response.data;
  },

  // Get single patient by ID
  getPatientById: async (id) => {
    const response = await api.get(`/patients/${id}`);
    return response.data;
  },

  // Create new patient
  createPatient: async (patientData) => {
    const response = await api.post('/patients', patientData);
    return response.data;
  },

  // Update patient
  updatePatient: async (id, patientData) => {
    const response = await api.put(`/patients/${id}`, patientData);
    return response.data;
  },

  // Delete patient
  deletePatient: async (id) => {
    const response = await api.delete(`/patients/${id}`);
    return response.data;
  },

  // Search patients
  searchPatients: async (query) => {
    const response = await api.get('/patients/search', { params: { q: query } });
    return response.data;
  },

  // Update patient status
  updatePatientStatus: async (id, status) => {
    const response = await api.patch(`/patients/${id}/status`, { status });
    return response.data;
  },
};

export default patientService;